import {
  GUIDELINE_EDIT, GUIDELINE_EDIT_FAILURE, GUIDELINE_EDIT_SUCCESS, GUIDELINE_UPDATE, GUIDELINE_UPDATE_FAILURE, GUIDELINE_UPDATE_SUCCESS
} from './mutation-types'

export default {
  state: {
    guideline: null
  },
  getters: {
    guideline: state => {
      return state.guideline
    }
  },
  actions: {
    [GUIDELINE_EDIT] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var callback = null
      if (data) {
        callback = data.callback
      }
      var url = '/master/guidelines/' + params.id
      dispatch('apiGet', {url: url, data: {id: params.id}, loadparams: true})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(GUIDELINE_EDIT_FAILURE, res.data)
            } else {
              res.data.callback = callback
              commit(GUIDELINE_EDIT_SUCCESS, res.data)
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [GUIDELINE_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/master/guidelines/' + params.id
      dispatch('apiPatch', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(GUIDELINE_UPDATE_FAILURE, res.data)
            } else {
              commit(GUIDELINE_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [GUIDELINE_EDIT_FAILURE] (state, data) {
      console.log('GUIDELINE_EDIT_FAILURE')
    },
    [GUIDELINE_EDIT_SUCCESS] (state, data) {
      console.log('GUIDELINE_EDIT_SUCCESS')
      state.guideline = data
      if (data.callback) {
        data.callback()
      }
    },
    [GUIDELINE_UPDATE_FAILURE] (state, data) {
      console.log('GUIDELINE_UPDATE_FAILURE')
    },
    [GUIDELINE_UPDATE_SUCCESS] (state, data) {
      console.log('GUIDELINE_UPDATE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/guideline-edit.js